import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import { matchPath } from "react-router-dom";
import "vidyoclient-nativewebrtc-sdk/dist/VidyoClient.css";

import { useVidyoStore } from "../utils/vidyo-store";

const viewID = "vidyo-call-view";
export default function CallRenderScreen() {
  const { vidyoSDK } = useVidyoStore();
  const viewArea = document.getElementById(viewID);
  const viewAreaRef = useRef<HTMLDivElement | null>(null);
  const isVidyoConnected = useVidyoStore((store) => store.isVidyoConnected);
  const isCallScreen = matchPath("/r/:key/call", location.pathname) !== null;

  useEffect(() => {
    if (vidyoSDK && viewAreaRef.current) {
      vidyoSDK
        .AssignViewToCompositeRenderer({
          viewId: viewID,
          viewStyle: "VIDYO_CONNECTORVIEWSTYLE_Default",
          remoteParticipants: 25,
        })
        .catch(() =>
          console.error("Unable to assign view to composite renderer."),
        );
    }

    return () => {
      if (vidyoSDK) vidyoSDK.HideView({ viewId: viewID });
    };
  }, [viewArea, vidyoSDK, viewAreaRef]);

  const shouldBeVisible = isVidyoConnected || !isCallScreen;
  return (
    <motion.div
      id={viewID}
      ref={viewAreaRef}
      initial={{ opacity: 0 }}
      animate={{ opacity: shouldBeVisible ? 1 : 0 }}
      transition={{ duration: 0.4 }}
      className="h-full w-full bg-foreground dark:bg-background"
    ></motion.div>
  );
}
